import { Button, ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import classnames from 'classnames';
import React from 'react';
import { Key } from 'ts-key-enum';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { RegexProvider } from '../../RegexProvider';

interface IExpectedDeliveryDateInputProps {
    onSearch: (postalCode: string) => void;
    initialPostalCode: string | null;
}

export const ExpectedDeliveryDateInput = ({ onSearch, initialPostalCode }: IExpectedDeliveryDateInputProps) => {
    const [postalCode, setPostalCode] = React.useState(initialPostalCode || '');
    const [showPostalCodeError, setShowPostalCodeError] = React.useState(false);

    const search = () => {
        if (!postalCode || !RegexProvider.postalCode.test(postalCode)) {
            return setShowPostalCodeError(true);
        }

        onSearch(postalCode);
    };

    const onPostalCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.currentTarget.value.length <= 4) {
            setShowPostalCodeError(false);
            setPostalCode(e.currentTarget.value);
        }
    };

    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === Key.Enter) search();
    };

    return (
        <div className="ExpectedDeliveryDateInput">
            <div className={classnames('NewForm__FieldWrapper', showPostalCodeError && 'NewForm__Error')}>
                <div className="ExpectedDeliveryDateInput__Field NewForm__Field">
                    <input
                        type="number"
                        placeholder={getTranslation(keys['expectedDeliveryDate.postalCode'])}
                        value={postalCode}
                        onChange={onPostalCodeChange}
                        onKeyDown={handleEnter}
                    />
                </div>

                <div className="ExpectedDeliveryDateInput__ValidationWrapper NewForm__ValidationWrapper">
                    {showPostalCodeError && <span className="NewForm__FieldError">{getTranslation(keys['expectedDeliveryDate.failPostalCode'])}</span>}
                </div>
            </div>
            <Button size={ButtonSize.Medium} className="ExpectedDeliveryDateInput__CheckButton" onClick={search}>
                <span className="hideOnDesktop">{getTranslation(keys['expectedDeliveryDate.check'])}</span>
                <span className="hideOnMobile">{getTranslation(keys['expectedDeliveryDate.checkDeliveryDate'])}</span>
            </Button>
        </div>
    );
};
